









import Vue from "vue";
import Navbar from "@/components/Navbar.vue";

export default Vue.extend({
  name: "LayoutDefault",
  components: {
    "c-navbar": Navbar,
  },
});
